"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var EditIcon = function EditIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16 3L21 8L8 21H3V16L16 3Z",
    stroke: "#13131C",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }));
};
exports.EditIcon = EditIcon;